const { __ } = window.wp.i18n;
/*
const countryListWithDuplicates = [
  { key: 'fr-ma', value: 'Morocco' },
  { key: 'ma-fr', value: 'Morocco' },
  { key: 'nl-nl', value: 'Netherlands' },
  { key: 'NL', value: 'Netherlands' },
  { key: 'es-mx', value: 'Mexico' },
  { key: 'mx-es', value: 'Mexico' },
  { key: 'it-it', value: 'Italy' },
  { key: 'it', value: 'Italy' },
  { key: 'ITA', value: 'Italy' },
  { key: 'cn-zh', value: 'China' },
  { key: 'CHN', value: 'China' },
  { key: 'zh-hans', value: 'China' },
  { key: 'es-es', value: 'Spain' },
  { key: 'de-de', value: 'Germany' },
  { key: 'DE', value: 'Germany' },
  { key: 'pl-pl', value: 'Poland' },
  { key: 'fr-fr', value: 'France' },
  { key: 'ae-en', value: 'UAE' },
  { key: 'en-ae', value: 'UAE' },
  { key: 'gb-en', value: 'United Kingdom' },
  { key: 'en-gb', value: 'United Kingdom' },
  { key: 'au-en', value: 'Australia' },
  { key: 'en-au', value: 'Australia' },
  { key: 'en-nz', value: 'New Zealand' },
  { key: 'nz-en', value: 'New Zealand' },
  { key: 'be-en', value: 'Belgium' },
  { key: 'en-be', value: 'Belgium' },
  { key: 'jp-jp', value: 'Japan' },
  { key: 'ja', value: 'Japan' },
  { key: 'us-en', value: 'United States' },
  { key: 'en-us', value: 'United States' },
  { key: 'in-en', value: 'India' },
  { key: 'en-in', value: 'India' },
  { key: 'no-no', value: 'Norway' },
  { key: 'SE', value: 'Sweden' },
  { key: 'se-en', value: 'Sweden' },
  { key: 'en-se', value: 'Sweden' },
  { key: 'NO', value: 'Norway' },
  { key: 'ro-en', value: 'Romania' },
  { key: 'en-ro', value: 'Romania' },
  { key: 'RO', value: 'Romania' },
  { key: 'at-de', value: 'Austria' },
  { key: 'AT', value: 'Austria' },
  { key: 'en-pt', value: 'Portugal' },
  { key: 'pt-en', value: 'Portugal' },
  { key: 'PRT', value: 'Portugal' },
  { key: 'PT', value: 'Portugal' },
  { key: 'co-es', value: 'Colombia' },
  { key: 'es-co', value: 'Colombia' },
  { key: 'CO', value: 'Colombia' },
  { key: 'fr-fr', value: 'France' },
  { key: 'en-gb', value: 'United Kingdom' },
  { key: 'au-en', value: 'Australia' },
  { key: 'nz-en', value: 'New Zealand' },
  { key: 'BE', value: 'Belgium' },
  { key: 'ja', value: 'Japan' },
  { key: 'en-us', value: 'United States' },
  { key: 'en-in', value: 'India' },
  { key: 'SE', value: 'Sweden' },
  { key: 'no-no', value: 'Norway' },
  { key: 'se-en', value: 'Sweden' },
  { key: 'NO', value: 'Norway' },
  { key: 'RO', value: 'Romania' },
  { key: 'en-ro', value: 'Romania' },
  { key: 'AT', value: 'Austria' },
  { key: 'PT', value: 'Portugal' },
  { key: 'DK', value: 'Denmark' },
  { key: 'FI', value: 'Finland' },
  { key: 'CH', value: 'Switzerland' },
  { key: 'en-ch', value: 'Switzerland' },
  { key: 'ch-en', value: 'Switzerland' },
  { key: 'DK', value: 'Denmark' },
  { key: 'dk-en', value: 'Denmark' },
  { key: 'FI', value: 'Finland' },
  { key: 'CH', value: 'Switzerland' },
  { key: 'en-ch', value: 'Switzerland' },
  { key: 'ch-en', value: 'Switzerland' },
  { key: 'HU', value: 'Hungary' },
  { key: 'pt-br', value: 'Brazil' },
  { key: 'cz-en', value: 'Czech Republic' },
  { key: 'en-cz', value: 'Czech Republic' },
  { key: 'CZ', value: 'Czech Republic' },
  { key: 'sg-en', value: 'Singapore' },
  { key: 'en-sg', value: 'Singapore' },
  { key: 'ar-es', value: 'Argentina' },
  { key: 'es-ar', value: 'Argentina' },
  { key: 'ca-fr', value: 'Canada' },
  { key: 'ca-en', value: 'Canada' },
  { key: 'en-ca', value: 'Canada' },
  { key: 'en-hk', value: 'Hong Kong SAR' },
  { key: 'sa-ar', value: 'Saudi Arabia' },
  { key: 'HU', value: 'Hungary' },
  { key: 'pt-br', value: 'Brazil' },
  { key: 'CZ', value: 'Czech Republic' },
  { key: 'en-sg', value: 'Singapore' },
  { key: 'es-ar', value: 'Argentina' },
  { key: 'fr-ma', value: 'Morocco' },
  { key: 'en-ca', value: 'Canada' },
  { key: 'en-hk', value: 'Hong Kong SAR' },
  { key: 'en-my', value: 'Malaysia' },
  { key: 'en-ph', value: 'Philippines' },
  { key: 'tn-fr', value: 'Tunisia' }
];
*/

const countryListWithDuplicates = [
  // { key: 'fr-ma', value: 'Morocco' },
  // { key: 'ma-fr', value: 'Morocco' },
  // { key: 'nl-nl', value: 'Netherlands' },
  // { key: 'NL', value: 'Netherlands' },
  // { key: 'es-mx', value: 'Mexico' },
  // { key: 'mx-es', value: 'Mexico' },
  // { key: 'it-it', value: 'Italy' },
  // { key: 'it', value: 'Italy' },
  // { key: 'ITA', value: 'Italy' },
  // { key: 'cn-zh', value: 'China' },
  // { key: 'CHN', value: 'China' },
  // { key: 'zh-hans', value: 'China' },
  // { key: 'es-es', value: 'Spain' },
  // { key: 'de-de', value: 'Germany' },
  // { key: 'DE', value: 'Germany' },
  // { key: 'pl-pl', value: 'Poland' },
  // { key: 'fr-fr', value: 'France' },
  // { key: 'ae-en', value: 'UAE' },
  // { key: 'en-ae', value: 'UAE' },
  // { key: 'gb-en', value: 'United Kingdom' },
  // { key: 'en-gb', value: 'United Kingdom' },
  // { key: 'au-en', value: 'Australia' },
  // { key: 'en-au', value: 'Australia' },
  // { key: 'en-nz', value: 'New Zealand' },
  // { key: 'nz-en', value: 'New Zealand' },
  // { key: 'be-en', value: 'Belgium' },
  // { key: 'en-be', value: 'Belgium' },
  // { key: 'jp-jp', value: 'Japan' },
  // { key: 'ja', value: 'Japan' },
  // { key: 'us-en', value: 'United States' },
  // { key: 'en-us', value: 'United States' },
  // { key: 'in-en', value: 'India' },
  // { key: 'en-in', value: 'India' },
  // { key: 'en-in', value: 'India' },
  // { key: 'en-in', value: 'India' },
  // { key: 'no-no', value: 'Norway' },
  // { key: 'SE', value: 'Sweden' },
  // { key: 'se-en', value: 'Sweden' },
  // { key: 'en-se', value: 'Sweden' },
  // { key: 'NO', value: 'Norway' },
  // { key: 'ro-en', value: 'Romania' },
  // { key: 'en-ro', value: 'Romania' },
  // { key: 'RO', value: 'Romania' },
  // { key: 'at-de', value: 'Austria' },
  // { key: 'AT', value: 'Austria' },
  // { key: 'en-pt', value: 'Portugal' },
  // { key: 'pt-en', value: 'Portugal' },
  // { key: 'PRT', value: 'Portugal' },
  // { key: 'PT', value: 'Portugal' },
  // { key: 'co-es', value: 'Colombia' },
  // { key: 'es-co', value: 'Colombia' },
  // { key: 'CO', value: 'Colombia' },
  // { key: 'fr-fr', value: 'France' },
  // { key: 'en-gb', value: 'United Kingdom' },
  // { key: 'au-en', value: 'Australia' },
  // { key: 'nz-en', value: 'New Zealand' },
  // { key: 'BE', value: 'Belgium' },
  // { key: 'ja', value: 'Japan' },
  // { key: 'en-us', value: 'United States' },
  // { key: 'en-in', value: 'India' },
  // { key: 'SE', value: 'Sweden' },
  // { key: 'no-no', value: 'Norway' },
  // { key: 'se-en', value: 'Sweden' },
  // { key: 'NO', value: 'Norway' },
  // { key: 'RO', value: 'Romania' },
  // { key: 'en-ro', value: 'Romania' },
  // { key: 'AT', value: 'Austria' },
  // { key: 'PT', value: 'Portugal' },
  // { key: 'DK', value: 'Denmark' },
  // { key: 'FI', value: 'Finland' },
  // { key: 'CH', value: 'Switzerland' },
  // { key: 'en-ch', value: 'Switzerland' },
  // { key: 'ch-en', value: 'Switzerland' },
  // { key: 'DK', value: 'Denmark' },
  // { key: 'dk-en', value: 'Denmark' },
  // { key: 'FI', value: 'Finland' },
  // { key: 'CH', value: 'Switzerland' },
  // { key: 'en-ch', value: 'Switzerland' },
  // { key: 'ch-en', value: 'Switzerland' },
  // { key: 'HU', value: 'Hungary' },
  // { key: 'pt-br', value: 'Brazil' },
  // { key: 'cz-en', value: 'Czech Republic' },
  // { key: 'en-cz', value: 'Czech Republic' },
  // { key: 'en-CZ', value: 'Czech Republic' },
  // { key: 'CZ', value: 'Czech Republic' },
  // { key: 'CZE', value: 'Czech Republic' },
  // { key: 'sg-en', value: 'Singapore' },
  // { key: 'en-sg', value: 'Singapore' },
  // { key: 'ar-es', value: 'Argentina' },
  // { key: 'es-ar', value: 'Argentina' },
  // { key: 'ca-fr', value: 'Canada' },
  // { key: 'ca-en', value: 'Canada' },
  // { key: 'en-ca', value: 'Canada' },
  // { key: 'en-hk', value: 'Hong Kong SAR' },
  // { key: 'sa-ar', value: 'Saudi Arabia' },
  // { key: 'HU', value: 'Hungary' },
  // { key: 'pt-br', value: 'Brazil' },
  // { key: 'CZ', value: 'Czech Republic' },
  // { key: 'en-sg', value: 'Singapore' },
  // { key: 'es-ar', value: 'Argentina' },
  // { key: 'fr-ma', value: 'Morocco' },
  // { key: 'en-ca', value: 'Canada' },
  // { key: 'en-hk', value: 'Hong Kong SAR' },
  // { key: 'en-my', value: 'Malaysia' },
  // { key: 'en-ph', value: 'Philippines' },
  // { key: 'tn-fr', value: 'Tunisia' },
  // { key: 'ma-en', value: 'Morocco' },
  // { key: 'en-ma', value: 'Morocco' },
  // { key: 'lu-en', value: 'Luxembourg' },
  // { key: 'en-lu', value: 'Luxembourg' },
  // { key: 'LU', value: 'Luxembourg' },
  // { key: 'ro-en', value: 'Romania' },
  // { key: 'en-ro', value: 'Romania' },
  // { key: 'ie-en', value: 'Ireland' },
  // { key: 'en-ie', value: 'Ireland' },
  // { key: 'IE', value: 'Ireland' },
  // { key: 'hu-en', value: 'Hungary' },
  // { key: 'en-hu', value: 'Hungary' },
  // { key: 'tn-en', value: 'Tunisia' },
  // { key: 'sk-en', value: 'Slovakia' },
  // { key: 'en-sk', value: 'Slovakia' },
  // { key: 'ua-en', value: 'Ukraine' },
  // { key: 'en-ua', value: 'Ukraine' },
  // { key: 'en-tn', value: 'Tunisia' }
  { key: 'fr-ma', value: __('Morocco', 'macs-react-jobs') },
  { key: 'ma-fr', value: __('Morocco', 'macs-react-jobs') },
  { key: 'nl-nl', value: __('Netherlands', 'macs-react-jobs') },
  { key: 'NL', value: __('Netherlands', 'macs-react-jobs') },
  { key: 'es-mx', value: __('Mexico', 'macs-react-jobs') },
  { key: 'mx-es', value: __('Mexico', 'macs-react-jobs') },
  { key: 'MX', value: __('Mexico', 'macs-react-jobs') },
  { key: 'it-it', value: __('Italy', 'macs-react-jobs') },
  { key: 'it', value: __('Italy', 'macs-react-jobs') },
  { key: 'IT', value: __('Italy', 'macs-react-jobs') },
  { key: 'ITA', value: __('Italy', 'macs-react-jobs') },
  { key: 'cn-zh', value: __('China', 'macs-react-jobs') },
  { key: 'zh-cn', value: __('China', 'macs-react-jobs') },
  { key: 'CHN', value: __('China', 'macs-react-jobs') },
  { key: 'zh-hans', value: __('China', 'macs-react-jobs') },
  { key: 'es-es', value: __('Spain', 'macs-react-jobs') },
  { key: 'ES', value: __('Spain', 'macs-react-jobs') },
  { key: 'DE', value: __('Germany', 'macs-react-jobs') },
  { key: 'de-de', value: __('Germany', 'macs-react-jobs') },
  { key: 'pl-pl', value: __('Poland', 'macs-react-jobs') },
  { key: 'PL', value: __('Poland', 'macs-react-jobs') },
  { key: 'en-pt', value: __('Portugal', 'macs-react-jobs') },
  { key: 'pt-en', value: __('Portugal', 'macs-react-jobs') },
  { key: 'PRT', value: __('Portugal', 'macs-react-jobs') },
  { key: 'PT', value: __('Portugal', 'macs-react-jobs') },
  { key: 'co-es', value: __('Colombia', 'macs-react-jobs') },
  { key: 'es-co', value: __('Colombia', 'macs-react-jobs') },
  { key: 'CO', value: __('Colombia', 'macs-react-jobs') },
  { key: 'fr-fr', value: __('France', 'macs-react-jobs') },
  { key: 'FR', value: __('France', 'macs-react-jobs') },
  { key: 'en-gb', value: __('United Kingdom', 'macs-react-jobs') },
  { key: 'gb-en', value: __('United Kingdom', 'macs-react-jobs') },
  { key: 'GB', value: __('United Kingdom', 'macs-react-jobs') },
  { key: 'au-en', value: __('Australia', 'macs-react-jobs') },
  { key: 'en-au', value: __('Australia', 'macs-react-jobs') },
  { key: 'AU', value: __('Australia', 'macs-react-jobs') },
  { key: 'nz-en', value: __('New Zealand', 'macs-react-jobs') },
  { key: 'en-nz', value: __('New Zealand', 'macs-react-jobs') },
  { key: 'NZ', value: __('New Zealand', 'macs-react-jobs') },
  { key: 'BE', value: __('Belgium', 'macs-react-jobs') },
  { key: 'be-en', value: __('Belgium', 'macs-react-jobs') },
  { key: 'en-be', value: __('Belgium', 'macs-react-jobs') },
  { key: 'ja', value: __('Japan', 'macs-react-jobs') },
  { key: 'JP', value: __('Japan', 'macs-react-jobs') },
  { key: 'en-us', value: __('United States', 'macs-react-jobs') },
  { key: 'us-en', value: __('United States', 'macs-react-jobs') },
  { key: 'US', value: __('United States', 'macs-react-jobs') },
  { key: 'en-in', value: __('India', 'macs-react-jobs') },
  { key: 'in-en', value: __('India', 'macs-react-jobs') },
  { key: 'IN', value: __('India', 'macs-react-jobs') },
  { key: 'SE', value: __('Sweden', 'macs-react-jobs') },
  { key: 'se-en', value: __('Sweden', 'macs-react-jobs') },
  { key: 'en-se', value: __('Sweden', 'macs-react-jobs') },
  { key: 'no-no', value: __('Norway', 'macs-react-jobs') },
  { key: 'NO', value: __('Norway', 'macs-react-jobs') },
  { key: 'RO', value: __('Romania', 'macs-react-jobs') },
  { key: 'AT', value: __('Austria', 'macs-react-jobs') },
  { key: 'DK', value: __('Denmark', 'macs-react-jobs') },
  { key: 'FI', value: __('Finland', 'macs-react-jobs') },
  { key: 'en-fi', value: __('Finland', 'macs-react-jobs') },
  { key: 'fi-en', value: __('Finland', 'macs-react-jobs') },
  { key: 'CH', value: __('Switzerland', 'macs-react-jobs') },
  { key: 'ch-en', value: __('Switzerland', 'macs-react-jobs') },
  { key: 'ch-fr', value: __('Switzerland', 'macs-react-jobs') },
  { key: 'en-ch', value: __('Switzerland', 'macs-react-jobs') },
  { key: 'ch-fr', value: __('Switzerland', 'macs-react-jobs') },
  { key: 'HU', value: __('Hungary', 'macs-react-jobs') },
  { key: 'pt-br', value: __('Brazil', 'macs-react-jobs') },
  { key: 'br-pt', value: __('Brazil', 'macs-react-jobs') },
  { key: 'BR', value: __('Brazil', 'macs-react-jobs') },
  { key: 'CZ', value: __('Czech Republic', 'macs-react-jobs') },
  { key: 'en-sg', value: __('Singapore', 'macs-react-jobs') },
  { key: 'sg-en', value: __('Singapore', 'macs-react-jobs') },
  { key: 'SG', value: __('Singapore', 'macs-react-jobs') },
  { key: 'es-ar', value: __('Argentina', 'macs-react-jobs') },
  { key: 'ar-es', value: __('Argentina', 'macs-react-jobs') },
  { key: 'AR', value: __('Argentina', 'macs-react-jobs') },
  { key: 'en-ca', value: __('Canada', 'macs-react-jobs') },
  { key: 'ca-en', value: __('Canada', 'macs-react-jobs') },
  { key: 'CA', value: __('Canada', 'macs-react-jobs') },
  { key: 'en-hk', value: __('Hong Kong SAR', 'macs-react-jobs') },
  { key: 'hk-en', value: __('Hong Kong SAR', 'macs-react-jobs') },
  { key: 'HK', value: __('Hong Kong SAR', 'macs-react-jobs') },
  { key: 'en-my', value: __('Malaysia', 'macs-react-jobs') },
  { key: 'my-en', value: __('Malaysia', 'macs-react-jobs') },
  { key: 'MY', value: __('Malaysia', 'macs-react-jobs') },
  { key: 'en-ph', value: __('Philippines', 'macs-react-jobs') },
  { key: 'ph-en', value: __('Philippines', 'macs-react-jobs') },
  { key: 'PH', value: __('Philippines', 'macs-react-jobs') },
  { key: 'tn-fr', value: __('Tunisia', 'macs-react-jobs') },
  { key: 'fr-tn', value: __('Tunisia', 'macs-react-jobs') },
  { key: 'TN', value: __('Tunisia', 'macs-react-jobs') },
  { key: 'LU', value: __('Luxembourg', 'macs-react-jobs') },
  { key: 'lu-en', value: __('Luxembourg', 'macs-react-jobs') },
  { key: 'en-lu', value: __('Luxembourg', 'macs-react-jobs') },
  { key: 'IE', value: __('Ireland', 'macs-react-jobs') },
  { key: 'ie-en', value: __('Ireland', 'macs-react-jobs') },
  { key: 'en-ie', value: __('Ireland', 'macs-react-jobs') }
];

// Removing duplicates
const countryListMap = new Map(countryListWithDuplicates.map(item => [item.key, item.value]));

// Converting map to array of objects in required format
const countryList = [];
countryListMap.forEach((value, key) => {
  countryList.push({
    key,
    value
  });
});

export {
  countryList, countryListMap
};
